import Swiper from 'swiper';

export default sliderOffersList => {
    // console.log('sliderOffersList');
    const swiperContainerOffers = sliderOffersList.querySelector('.swiper-offers-list');
    const swiperContainer = swiperContainerOffers.querySelector('.swiper-container');

    const offersListSlider = new Swiper(swiperContainer, {
        init: false,
        slidesPerView: 'auto',
        spaceBetween: 10,
        grabCursor: true,
    });

    if (window.innerWidth < 992) {
        offersListSlider.init();
    }
};
